<template>
    <div class="main-con el-main">
        <nav-breadcrumb :menu="[{label: '助贷放款明细表'}]"/>
        <el-row class="xzpadd10 bg-purple">
            <!-- -->

            <data-table
                :tableData="listData"
                :columns="listColumns"
                :pageSize.sync="pageSize"
                :page.sync="page"
                :filters="filters"
                :actions="actions"
                :is-pagination-show="false"
            >
                <div slot="TableTop">
                    <el-col :span="6"><div class="Htitle-text color-deep-blue">贷款本金合计：{{(totalAmounts/10000).toFixed(2)||''}}</div></el-col>
                    <el-col :span="6"><div class="Htitle-text color-deep-blue">笔数合计：{{listData.count}}</div></el-col>
                    <el-col :span="6"><div class="Htitle-text color-deep-blue">放款日期查询范围：{{filters.form.fi__startDate[0]|moment('YYYY-MM-DD')}}-{{filters.form.fi__startDate[1]|moment('YYYY-MM-DD')}}</div></el-col>
                </div>
            </data-table>
        </el-row>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import moment from 'moment'
    import Status2CN from "../../filters/Status2CN";
    import {xmlBuildQuery} from "../../filters/CommonActions";
    import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "FinancingList",
        data() {
            return {
                page: 1,
                pageSize: 20,
                listData: {},
                totalAmounts:0,
                balanceAmounts:0,
                listColumns: [
                    {
                        name: '序号',
                        type: 'index'
                    },
                    {
                        name: '贷款编号',
                        field: 'fi__transactionNo'
                    },
                    {
                        name: '客户姓名',
                        field: 'fi__customerName'
                    },
                    /*{
                        name: '手机号',
                        field: 'c__customerContactNo'
                    },*/
                    {
                        name: '渠道商',
                        field: 'd__dealerName'
                    },
                    {
                        name: '资方',
                        field: 'l__lenderName'
                    },
                    {
                        name: '贷款金额',
                        field: 'fi__totalAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)
                        }
                    },
                    {
                        name: '合同利率（%）',
                        field: 'fi__interestRate',
                        formatter: function (r,c,v) {
                            if(v)
                                return (v*100).toFixed(3)+'%(年利率)'
                            else
                                return ''
                        }
                    },
                    {
                        name: '资方收益率（%）',
                        field: 'lfi__interestRate',
                        formatter: function (r,c,v) {
                            if(v)
                                return (v*100).toFixed(3)+'%(年利率)'
                            else
                                return ''
                        }
                    },
                    {
                        name: '开始日期',
                        field: 'fi__startDate',
                        formatter: function (r,c,v) {
                            if(v)
                                return moment(v).format('YYYY-MM-DD')
                        }
                    },

                    {
                        name: '结束日期',
                        field: 'fi__endDate',
                        formatter: function (r,c,v) {
                            if(v)
                                return moment(v).format('YYYY-MM-DD')
                        }
                    },
                    {
                        name: '贷款余额',
                        field: 'fi__outstandingAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)
                        }
                    },
                    {
                        label: '状态',
                        field: 'fi__transactionStatus',
                        formatter: function (r,c,v) {
                            if(v)
                                return Status2CN('Financing_'+v)
                            else
                                return''
                        }
                    },

                ],
                filters: {
                    form: {
                        fi__startDate: [],
                        fi__customerName:'',
                        l__lenderId:'',
                        fi__transactionStatus:'',
                        d__dealerId:''
                    },
                    columns: [

                        {
                            label: '放款日',
                            component: 'date-range-picker',
                            field: 'fi__startDate',
                        },
                        {
                            label: '客户姓名',
                            component: 'el-input',
                            field: 'fi__customerName',
                        },
                        {
                            label: '渠道商',
                            component: 'el-select',
                            field: 'd__dealerId',
                            options:[],
                            span: 12
                        },
                        {
                            label: '资方',
                            component: 'el-select',
                            field: 'l__lenderId',
                            options:[],
                            span: 12
                        },
                        {
                            label: '状态',
                            component: 'el-select',
                            field: 'fi__transactionStatus',
                            options: [
                                {
                                    label: '全部',
                                    value: ''
                                },
                                {
                                    label: '待放款',
                                    value: 'Ready'
                                },
                                {
                                    label: '放款中',
                                    value: 'Paying'
                                },
                                {
                                    label: '还款中',
                                    value: 'Processing'
                                },
                                {
                                    label: '已还清',
                                    value: 'Settled'
                                }
                            ],
                            op: 'eq',
                            span: 12
                        },

                    ],
                    onSubmit:()=>{
                        this.page = 1
                        this.getData()
                    },
                    onReset: ()=> {
                        this.filters.form = {
                            fi__startDate: [],
                            fi__customerName:'',
                            l__lenderId:'',
                            fi__transactionStatus:'',
                            d__dealerId:''
                        }
                        this.listData= {
                            count: 0,
                            data: []
                        }
                        this.totalAmounts = 0
                        this.balanceAmounts = 0
                    }
                },
                actions: [
                    {
                        label: '导出',
                        clickHandler:()=>{
                            let routeData = this.$router.resolve({
                                path: '/ix/fang/financing/lender/reporting/Financing.List?format=xls',
                                query: Object.assign({ pageSize:0,}, this.filterParams, xmlBuildQuery(this.filters))
                            });
                            window.open(routeData.href.replace('#/', '/'), '_blank');
                        }
                    }
                ],
            }
        },
        computed : {
            filterParams: {
                get: function() {
                    return {
                        /* pageSize: this.pageSize,
                         pageOffset: (this.page - 1) * this.pageSize,*/
                        /* 'xlist.sort.dataField': 'fi.transactionDate',
                         'xlist.sort.order': 'desc'*/
                    }
                },
                set:function (newVal) {

                }
            }
        },
        watch: {
            filterParams: function () {
                this.getData()
            }
        },
        mounted() {
            //this.getData()
            this.getLenderList()
            this.getDealerList()
        },
        methods: {
            getData: function () {
                xhr.getLenderFinancingListList(
                    Object.assign({
                        pageSize:0,
                    }, this.filterParams, xmlBuildQuery(this.filters)),
                    res=> {
                        try {
                            this.totalAmounts= 0
                            this.balanceAmounts = 0
                            let outstandingAmount = 0
                            this.listData = res.data
                            this.listData.data.forEach(item=>{
                                if(item.fi__totalAmount){
                                    this.totalAmounts = this.totalAmounts +parseFloat(item.fi__totalAmount)*10000
                                }
                                if(item.fi__balanceAmount){
                                    this.balanceAmounts = this.balanceAmounts +parseFloat(item.fi__balanceAmount)*10000
                                }
                                if(item.fi__outstandingAmount){
                                    outstandingAmount = outstandingAmount +parseFloat(item.fi__outstandingAmount)*10000
                                }
                            })

                            this.listData.data.push({
                                fi__transactionNo:'合计',
                                fi__totalAmount:(this.totalAmounts/10000).toFixed(2)||'',
                                fi__balanceAmount:(this.balanceAmounts/10000).toFixed(2)||'',
                                fi__outstandingAmount:(outstandingAmount/10000).toFixed(2)||''
                            })
                        }catch(e){

                        }
                    })

            },
            getLenderList: function () {
                xhr.getLenderList(
                    Object.assign({pageSize:0}, this.filterParams, {}),
                    res=> {
                        try {
                            this.filters.columns[3].options = res.data.data.map(item=>{
                                return {
                                    label: item.d__lenderName,
                                    value:item.d__lenderId,
                                }
                            })
                        }catch(e){

                        }
                    })

            },
            getDealerList: function () {
                xhr.getDealerList(
                    Object.assign({
                        'xlist.search.d.forLender':'Y',
                        'xlist.search.d.forLender.op':'eq',
                        pageSize:0}, this.filterParams, xmlBuildQuery(this.filters)),
                    res=> {
                        try {
                            this.filters.columns[2].options = res.data.data.map(item=>{
                                return {
                                    label: item.d__dealerName,
                                    value:item.d__dealerId,
                                }
                            })
                        }catch(e){

                        }
                    })

            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/FinancingList.vue